<div class="pcm-modal">
  <div class="pcm-modal__header">
    <h3 class="pcm-modal__title"><i class="fas fa-comments mr-2"></i>Comunicación externa</h3>
    <button type="button" class="pcm-modal__close" aria-label="Cerrar" (click)="close()">
      <i class="fas fa-times-circle"></i>
    </button>
  </div>
  <div class="pcm-modal__body">
    <p class="pcm-modal__subtitle">Hilo de comunicación del portal externo</p>

    <div *ngIf="contactEmailWarning" class="pcm-modal__warning" role="alert">
      <i class="fas fa-exclamation-triangle mr-2" aria-hidden="true"></i>
      <span>
        {{ contactEmailWarning }}
        <button type="button" class="pcm-modal__warning-link" (click)="goToCounterpartiesAdmin()">
          {{ contactEmailAdminLinkLabel }}
        </button>.
      </span>
    </div>

    <div *ngIf="loading" class="pcm-modal__loading">
      <span class="spinner-border text-primary"></span>
    </div>

    <ng-container *ngIf="!loading">
      <div class="pcm-modal__list">
        <div *ngFor="let c of commentsList" class="pcm-modal__message" [class.pcm-modal__message--client]="c.fromClient">
          <div class="pcm-modal__message-header">
            <strong>{{ getCommentAuthor(c) }}</strong>
            <small>{{ formatDate(c.date) }}</small>
            <span *ngIf="!c.fromClient && c.readAt" class="pcm-modal__read-badge" title="Leído en el portal"><i class="fas fa-check-double"></i> Leído</span>
            <a *ngIf="getCommentAttachments(c).length" [href]="getCommentAttachments(c)[0].url" target="_blank" rel="noopener noreferrer" class="pcm-modal__attach-icon" [title]="getCommentAttachments(c).length === 1 ? 'Ver adjunto' : 'Ver adjuntos'"><i class="fas fa-paperclip"></i></a>
          </div>
          <p class="pcm-modal__message-text">{{ c.note }}</p>
          <div *ngIf="getCommentAttachments(c).length" class="pcm-modal__attachments">
            <span class="pcm-modal__attachments-label"><i class="fas fa-paperclip mr-1"></i>Adjunto(s):</span>
            <div class="pcm-modal__attachment-links">
              <a *ngFor="let att of getCommentAttachments(c)" [href]="att.url" target="_blank" rel="noopener noreferrer" class="pcm-modal__attachment-link"><i class="fas fa-file-download mr-1"></i>{{ att.filename }}</a>
            </div>
          </div>
        </div>
        <div *ngIf="commentsList.length === 0" class="pcm-modal__empty">
          <i class="fas fa-comments text-muted"></i>
          <p class="mb-0 text-muted">Sin mensajes en el hilo</p>
        </div>
      </div>

      <div class="pcm-modal__form">
        <div class="pcm-modal__bar">
          <input type="file" #fileInput id="modal-comment-file-input" class="pcm-modal__file-input" (change)="onFileSelected($event)" [disabled]="sending" accept="*/*">
          <button type="button" class="pcm-modal__clip" (click)="fileInput.click()" [disabled]="sending" title="Adjuntar archivo"><i class="fas fa-paperclip"></i></button>
          <textarea [(ngModel)]="newComment" placeholder="Escribe un mensaje..." rows="2" class="pcm-modal__textarea"></textarea>
          <button type="button" class="pcm-modal__send btn btn-success" (click)="sendComment()" [disabled]="(!newComment?.trim() && !commentFile) || sending" title="Enviar">
            <span *ngIf="sending" class="spinner-border spinner-border-sm"></span>
            <i *ngIf="!sending" class="fas fa-paper-plane"></i>
          </button>
        </div>
        <div *ngIf="commentFile" class="pcm-modal__file-chip">
          <i class="fas fa-file-alt"></i>
          <span>{{ commentFile.name }}</span>
          <button type="button" class="pcm-modal__file-chip-remove" (click)="clearFile()" title="Quitar">&times;</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
